import { CatalogItemArtworkFile } from '../../../redux/api/fymAPI.types';
import { drawnFileSrc, drawnRemoteSrc } from '../../common/drawnImageSrc';
import { getFullAPIFileURL } from '../../common/getFullAPIFileURL';

/** The two fields a catalog row can carry its cover art in. */
export interface CatalogArtworkSource {
  /** An absolute url, snapshotted off the release at claim time. */
  artworkUrl: string | null;
  /** Our own copy of the cover. `sourceUrl` is its imgproxy source; `url` streams the original. */
  artworkFile: CatalogItemArtworkFile | null;
}

/**
 * What to put in the `src` of a catalog row's cover, for a cover drawn `cssPx` CSS pixels wide.
 *
 * The stored file wins: the artist chose it, and on an unreleased row it is the only cover there
 * is. Owner rule 2026-10-19: the cover goes through imgproxy, sized for the place (the file route
 * streams the original, 2.5 MB for a 40 px tile, and a page of them timed out). A streaming
 * service cover goes through imgproxy too when its host is on the allow list.
 *
 * Every place that draws a catalog cover goes through here.
 */
export function catalogArtworkSrc(item: CatalogArtworkSource, cssPx: number): string | undefined {
  if (item.artworkFile !== null) {
    return drawnFileSrc(item.artworkFile, cssPx);
  }
  if (item.artworkUrl === null || item.artworkUrl === '') {
    return undefined;
  }
  return drawnRemoteSrc(item.artworkUrl, cssPx);
}

/**
 * The cover as the original address, NOT for an `<img>`: for a value that the app passes on (a
 * release resolution, a "has a cover" check). Draw a cover with `catalogArtworkSrc`.
 */
export function catalogArtworkOriginalSrc(item: CatalogArtworkSource): string | undefined {
  if (item.artworkFile !== null) {
    return getFullAPIFileURL(item.artworkFile.url);
  }
  return item.artworkUrl ?? undefined;
}
